"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../../../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('capsule-core-js'),
    MEW = _require.MEW; // Setup CSS Module


var cx = _bind.default.bind(_indexModule.default);

const STATUS = {
  INIT: 'Please use MyEtherWallet application on your phone to scan and establish the connection!',
  TEST: 'Waiting for the connection...',
  FAIL: 'Cannot connect the devide!'
};

class MewAsset extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "establishTheConnection", () => {
      let options = {
        getApproval: window.kambriaWallet.getApproval,
        getAuthentication: window.kambriaWallet.getAuthentication
      };
      this.mew = new MEW(window.kambriaWallet.networkId.ethereum, options);
      this.mew.setAccountByMEW((er, re) => {
        if (er) return this.setState({
          message: STATUS.FAIL
        });
        return this.done({
          wallet: 'mew',
          model: 'my-ether-wallet',
          provider: this.mew
        });
      });
    });

    this.state = {
      message: STATUS.INIT
    };
    this.done = props.done;
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cx("tab-pane", "fade", "show", "active")
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: cx("d-block", "text-center", "mt-5", "mb-3"),
      style: {
        fontSize: "16px",
        lineHeight: "18px"
      }
    }, this.state.message), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-sm", "btn-primary", "d-block", "text-center", "mx-auto", "mb-5"),
      onClick: this.establishTheConnection
    }, "Connect"));
  }

}

var _default = MewAsset;
exports.default = _default;